export default __webpack_public_path__ + "static/media/microscope.7550d15e.png";